import { useCallback, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

import { isNotificationsCentrePathname } from "@/constants/notificationsCentre"
import { useOptionalNotificationsInbox } from "@/contexts/NotificationsInboxContext"
import { fetchNotifications } from "@/services/notificationsApi"

export function useUnreadNotificationCount(
  enabled = true,
  menuOpen = false
): number {
  const inbox = useOptionalNotificationsInbox()
  const { pathname } = useLocation()
  const notificationsCentreActive = isNotificationsCentrePathname(pathname)
  const [unreadCount, setUnreadCount] = useState(0)

  const refresh = useCallback(async () => {
    try {
      const { unreadCount: backendUnread, notifications } = await fetchNotifications({
        limit: 1,
      })
      if (typeof backendUnread === "number") {
        setUnreadCount(Math.max(0, backendUnread))
        return
      }
      setUnreadCount(
        Math.max(0, notifications.filter((n) => n.statusInApp === "unread").length)
      )
    } catch (error) {
      console.error("Failed to fetch unread notification count:", error)
    }
  }, [])

  useEffect(() => {
    if (!enabled || notificationsCentreActive) {
      return
    }
    void refresh()
  }, [enabled, menuOpen, notificationsCentreActive, pathname, refresh])

  useEffect(() => {
    if (!enabled || notificationsCentreActive) {
      return
    }

    const onWsNotification = () => {
      void refresh()
    }

    window.addEventListener("notifications:ws", onWsNotification as EventListener)
    return () => {
      window.removeEventListener("notifications:ws", onWsNotification as EventListener)
    }
  }, [enabled, notificationsCentreActive, refresh])

  if (notificationsCentreActive && inbox) {
    return inbox.unreadCount
  }

  return unreadCount
}
